




























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import {
  AccountStateEnum,
  AccountTypeEnum,
  AgentTypeEnum,
  OCTBAccountPermissionEnum,
} from '@/api/types';
import {
  list_accounts,
  listAccounts,
  getAccount,
  put_account,
  putAccount,
} from '@/api/account';
import { list_agent_summaries, listAgentSummaries } from '@/api/agent';
import {
  formatApiError,
  stringFromIDate,
  monthStringFromIDate,
} from '@/utils/index';
import { AppRoleType } from '@/utils/types';
import { translateRouteTitle } from '@/utils/permission';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'AccountCreate',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  private readonly defaultNewAccount: put_account.Account = {
    type: AccountTypeEnum.AGT,
    id: '',
    agentId: '',
    state: AccountStateEnum.ACTIVE,
    password: '',
    octbAccountPermissions: [],
  };
  private loading = true;
  private valid = false;
  private newAccount = Object.assign({}, this.defaultNewAccount);
  private idRules: ((v: string) => boolean | string)[] = [];
  private accountTypeRules: ((v: string) => boolean | string)[] = [];
  private agentIdRules: ((v: string) => boolean | string)[] = [];
  private passwordRules: ((v: string) => boolean | string)[] = [];
  private agentItems: ItemType[] = [];
  private octbAccountPermissionItems: ItemType[] = [];
  private showPassword = false;
  private createdAccountId = '';
  private redirectAfterCreate = true;
  private showRedirectAfterCreate = true;
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';
  private showCopyAccounts = false;
  private canCopyAccounts = false;
  private copyAccountType = '';
  private copyAgentId = '';
  private copyAccountId = '';
  private accounts: Map<string, list_accounts.Account> | null = null;
  private accountItems: ItemType[] = [];

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get canModifyAccountType() {
    return (
      false &&
      UserModule.roles.some(
        r =>
          (r as AppRoleType) === AppRoleType.ADMIN ||
          (r as AppRoleType) === AppRoleType.SUPPLIER
      )
    );
  }

  get canModifyAgentId() {
    return (
      this.newAccount.type &&
      (this.newAccount.type as AccountTypeEnum) === AccountTypeEnum.AGT
    );
  }

  get accountTypeItems(): ItemType[] {
    return Object.values(AccountTypeEnum)
      .filter(
        t => (t as AccountTypeEnum) !== AccountTypeEnum.UNKNOWN_ACCOUNT_TYPE
      )
      .map(t => ({
        text: this.$t(`AccountTypeEnum.${t}`) as string,
        value: t,
      }));
  }

  get accountTypeItemsNoAdmin(): ItemType[] {
    return Object.values(AccountTypeEnum)
      .filter(
        t =>
          (t as AccountTypeEnum) !== AccountTypeEnum.UNKNOWN_ACCOUNT_TYPE &&
          (t as AccountTypeEnum) !== AccountTypeEnum.LINKTIVITY
      )
      .map(t => ({
        text: this.$t(`AccountTypeEnum.${t}`) as string,
        value: t,
      }));
  }

  get accountStateFalseValue() {
    return AccountStateEnum.INACTIVE;
  }

  get accountStateTrueValue() {
    return AccountStateEnum.ACTIVE;
  }

  get showOctbAccountPermissions() {
    return (this.newAccount.type as AccountTypeEnum) !== AccountTypeEnum.AGT;
  }

  get canShowCopyAgent() {
    return (this.copyAccountType as AccountTypeEnum) === AccountTypeEnum.AGT;
  }

  get canShowCopyAccount() {
    return (
      this.copyAccountType &&
      ((this.canShowCopyAgent && this.copyAgentId) || !this.canShowCopyAgent)
    );
  }

  get canCreate() {
    return this.valid;
  }

  mounted() {
    this.fetchDataThenLoadRules();
  }

  private async fetchDataThenLoadRules() {
    await this.fetchData();
    this.$nextTick(() => {
      this.loadRules();
    });
  }

  private loadRules() {
    this.idRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Account Id'),
        }) as string),
    ];
    this.accountTypeRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Account type'),
        }) as string),
    ];
    this.agentIdRules = [
      (v: string) =>
        (this.newAccount.type as AccountTypeEnum) !== AccountTypeEnum.AGT ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Agent name'),
        }) as string),
    ];
    this.passwordRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Password'),
        }) as string),
    ];
  }

  private validate(): boolean {
    return (this.$refs.form as any).validate();
  }

  private resetValidation() {
    (this.$refs.form as any).resetValidation();
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';
    this.showRedirectAfterCreate = true;
    this.showCopyAccounts = false;
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForCreate() {
    this.dialogTextTitle = `${this.translateRouteTitle(
      this.$route.meta.title
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = true;
    this.showCopyAccounts = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.createAccount();
    };
    this.dialog = true;
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyAccounts = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private async showDialogForCopy() {
    this.dialogTextTitle = `${this.$t('Copy from other {msg}', {
      msg: this.$t('Account'),
    })}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyAccounts = true;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.copyAccount();
    };
    this.dialog = true;
  }

  private async fetchThenLoadAccounts() {
    if (this.copyAccountType) {
      try {
        let accounts: list_accounts.Account[] = [];
        if (this.canShowCopyAgent) {
          if (!this.copyAgentId) {
            return;
          }
          const res = await listAccounts({
            type: AccountTypeEnum.AGT,
            agentId: this.copyAgentId,
            includeInactive: true,
          });
          accounts = res.accounts;
        } else {
          const res = await listAccounts({
            type: this.copyAccountType as AccountTypeEnum,
            agentId: 'dummy',
            includeInactive: true,
          });
          accounts = res.accounts;
        }
        this.accounts = new Map(accounts.map(a => [a.id, a]));
        this.accountItems = accounts.map(a => ({
          text: a.id,
          value: a.id,
        }));
      } catch (err) {
        this.$toast.error(
          this.$t('Failed to {do} due to {err}', {
            do: (this.$t('Fetch {msg}', {
              msg: this.$t('Account'),
            }) as string).toLowerCase(),
            err: formatApiError(this.$i18n, err),
          }) as string,
          {
            icon: 'mdi-alert',
          }
        );
      }
    }
  }

  private async copyAccount() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const res = await getAccount({ id: this.copyAccountId });
      const account = res.account;
      this.newAccount = {
        id: '',
        type: account.type,
        agentId: account.agentId || '',
        state: account.state,
        password: '',
        octbAccountPermissions: account.octbAccountPermissions,
      };
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Account'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    AppModule.StopProgress();
    this.loading = false;
  }

  private async fetchData(noLoading = false) {
    if (!noLoading) {
      this.loading = true;
      AppModule.StartProgress();
    }

    await this.loadAgentItems();
    if (this.agentItems.length > 0) {
      this.newAccount.agentId = this.agentItems[0].value;
    }
    this.loadOctbAccountPermissionItems();

    if (!noLoading) {
      AppModule.StopProgress();
      this.loading = false;
    }
  }

  private async loadAgentItems() {
    try {
      const listAgentsRes = await listAgentSummaries({
        agentTypes: Object.values(AgentTypeEnum).filter(
          t => (t as AgentTypeEnum) !== AgentTypeEnum.UNKNOWN_AGENT_TYPE
        ),
      } as list_agent_summaries.Request);
      const items: ItemType[] = [];
      listAgentsRes.agentSummaries.forEach(a => {
        items.push({
          text: a.name,
          value: a.id,
        });
      });
      this.agentItems = items;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Agent'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private loadOctbAccountPermissionItems() {
    const items: ItemType[] = [];
    Object.values(OCTBAccountPermissionEnum).forEach(e => {
      if (
        (e as OCTBAccountPermissionEnum) !==
        OCTBAccountPermissionEnum.UNKNOWN_ROLE
      ) {
        items.push({
          text: this.$t(`OCTBAccountPermissionEnum.${e}`) as string,
          value: e,
        });
      }
    });
    this.octbAccountPermissionItems = items;
  }

  private reset() {
    this.newAccount = Object.assign({}, this.defaultNewAccount);
    this.showPassword = false;
  }

  private async createAccount() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const account: put_account.Account = {
        type: this.newAccount.type,
        id: this.newAccount.id,
        state: this.newAccount.state,
        password: this.newAccount.password,
        octbAccountPermissions: this.newAccount.octbAccountPermissions,
      };
      if ((this.newAccount.type as AccountTypeEnum) === AccountTypeEnum.AGT) {
        account.agentId = this.newAccount.agentId;
      }

      await putAccount({
        account: account,
      } as put_account.Request);
      await this.postCreate(account.id);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
      await this.postCreate();
    }

    AppModule.StopProgress();
    this.loading = false;
  }

  private async postCreate(accountId?: string) {
    if (this.redirectAfterCreate && accountId) {
      this.$nextTick(() => {
        this.$router.push(`/account/${accountId}`);
      });
    } else {
      this.reset();
      await this.fetchData(true);

      if (accountId) {
        this.createdAccountId = accountId;

        this.$toast.success(
          this.$t('Succeeded {do}', {
            do: (this.translateRouteTitle(
              this.$route.meta.title
            ) as string).toLowerCase(),
          }) as string,
          {
            icon: this.$route.meta.icon,
          }
        );
      }
    }
  }

  private getAccountStateText(state: AccountStateEnum) {
    return (state as AccountStateEnum) === AccountStateEnum.ACTIVE
      ? this.$t('Active')
      : this.$t('Inactive');
  }

  private getRequiredRules(
    msg: any,
    exception: (v: any) => boolean = () => false
  ) {
    return [
      (v: string) =>
        exception(v) ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$te(msg) ? this.$t(msg) : msg,
        }) as string),
    ];
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
